"use client";
import Image from "next/image";
import { v4 as uuidv4 } from 'uuid';
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
export const Captcha = () => {
  const [uuid, setUuid] = useState(() => uuidv4());
  const { setValue } = useFormContext();
  const handleRefresh = () => {
    const uuid = uuidv4();
    setUuid(uuid);
    setValue("uuid", uuid);
  };
  useEffect(() => {
    handleRefresh();
  }, []);

  return (
    <Image 
    suppressHydrationWarning={true} 
     src={`/api/auth/system/resource/v1/captcha?uuid=${uuid}`} 
     onClick={handleRefresh} alt="验证码" 
     className="cursor-pointer w-[132px] h-10" 
     width={132} height={40} />
  );
};
